import Menu from './Menu.jsx';
import Sports from './Sports.jsx';
import Sport from './Sport.jsx';
import League from './League.jsx';
import Match from './Match.jsx';
import MatchStats from './MatchStats.jsx';
import MainScore from './MainScore.jsx';
import AdditionalScores from './AdditionalScores.jsx';
import AdditionalScore from './AdditionalScore.jsx';

export const MenuElements = {
    sportsElement: Sports,
    sportElement: Sport,
    leagueElement: League,
    matchElement: Match,
    matchStatsElement: MatchStats,
    mainScoreElement: MainScore,
    additionalScoresElement: AdditionalScores,
    additionalScoreElement: AdditionalScore
};

export default Menu;



// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/live/index.js